const getEntityName = project => {
  if (!project.bankAccount) {
    return
  }

  return project.bankAccount.beneficiaryName
}

export default getEntityName